import { useIntl } from 'gatsby-plugin-react-intl';

import { CurrencySelect as UICurrencySelect } from '@workspace/ui';

import { useCurrencyContext } from '../../hooks/useCurrencyContext';

export interface CurrencySelectProps {
    triggerClassName?: string;
}

/** The shared currency dropdown, bound to the site-wide currency context. */
export const CurrencySelect = ({ triggerClassName }: CurrencySelectProps) => {
    const { formatMessage } = useIntl();
    const { currency, setCurrency } = useCurrencyContext();

    return (
        <UICurrencySelect
            currentCurrency={currency}
            onCurrencyChange={setCurrency}
            triggerClassName={triggerClassName}
            aria-label={formatMessage({ id: 'navbar.languageAndCurrencySwitcher.currency.title' })}
        />
    );
};
